import React from "react";
import { Field } from "react-final-form";

import Radio from "@components/Form/Radio";

const RadioInput = (props) => {
  if (props.valid) {
    return (
      <Field
        id={props.label}
        value={props.label}
        name={props.name}
        component={Radio}
        label={props.label}
        type="radio"
      />
    );
  }

  // Invalid component
  return null;
};

export default RadioInput;
